import { ButtonCSSReset } from '../../Button/skins/ButtonCSSReset';
import styled from 'styled-components';
export var IconButtonSkin = styled(ButtonCSSReset).withConfig({
  displayName: "IconButtonSkin",
  componentId: "sc-1x2y26i-0"
})(["flex:0 0 auto;width:48px;color:rgba(0,0,0,0.54);height:48px;padding:0;text-align:center;transition:background-color 150ms cubic-bezier(0.4,0,0.2,1) 0ms;border-radius:50%;&:hover{background-color:rgba(0,0,0,0.08);}}"]);